export default "__VITE_ASSET__BfoMXjO4__"